import {
  Card,
  Typography,
  Button,
  Form,
  Select,
  Input,
  DatePicker,
  message,
  Space,
  
} from "antd";
import {
  DownOutlined, UpOutlined, ReloadOutlined, PlayCircleOutlined, FileTextOutlined, FilePdfOutlined,
} from "@ant-design/icons";
import React, { forwardRef, useEffect, useState, useRef } from "react";
import dayjs from "dayjs";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable } from "@/hocComponents";
import OwnerGroupPicker from "../OneLineCashFlowReport/OwnerGroupPicker";
import CheckNoDetailModal from "./component/CheckNoDetailModal";
import "../OneLineCashFlowReport/index.css";
import "./index.css";
const { RangePicker } = DatePicker;
const ReportPage = forwardRef((_props, _ref) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const controllersRef = useRef([]);
  const [filtersCollapsed, setFiltersCollapsed] = useState(false);
  const [ownerGroupId, setOwnerGroupId] = useState(null);
  const [reportPeriod, setReportPeriod] = useState("");
  const [tableHeight, setTableHeight] = useState(300);
  const tableHost = useRef(null);
  const [exportPdfLoading, setExportPdfLoading] = useState(false);
  const [exportCsvLoading, setExportCsvLoading] = useState(false);
const [checkNoModalOpen, setCheckNoModalOpen] = useState(false);
const [checkNoRecord, setCheckNoRecord] = useState(null);
  const createController = () => {
    const controller = new AbortController();
    controllersRef.current.push(controller);
    return controller;
  };

  const cancelAllRequests = () => {
    controllersRef.current.forEach((c) => c?.abort());
    controllersRef.current = [];
  };

  const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    // Delay revoke to avoid breaking download in some browsers
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  };
  // Popover 的内容

  const getExportParams = async () => {
    await filterForm.validateFields();
    return buildReportParams(filterForm.getFieldsValue());
  };

  const toBlob = (val, mimeType) => {
    if (!val) return new Blob([], { type: mimeType });
    if (val instanceof Blob) return val;
    if (val instanceof ArrayBuffer) return new Blob([val], { type: mimeType });
    if (val instanceof Uint8Array) return new Blob([val], { type: mimeType });

    if (val?.type === "Buffer" && Array.isArray(val.data)) {
      return new Blob([new Uint8Array(val.data)], { type: mimeType });
    }

    if (Array.isArray(val)) {
      return new Blob([new Uint8Array(val)], { type: mimeType });
    }

    if (typeof val === "string") {
      let base64 = val;
      const dataUrlMatch = /^data:([^;]+);base64,(.*)$/.exec(val);
      if (dataUrlMatch) base64 = dataUrlMatch[2];

      const binary = atob(base64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      return new Blob([bytes], { type: mimeType });
    }

    if (typeof val === "object" && typeof val.base64 === "string") {
      return toBlob(val.base64, mimeType);
    }

    throw new Error("Invalid file data");
  };

  const handleExportPdf = async () => {
    if (exportPdfLoading) return;
    setExportPdfLoading(true);
    try {
      const params = await getExportParams();
      const responseBlob = await http.post(api.getGeneralLedgerToPdf, params, {
        responseType: "blob",
      });

      if (responseBlob instanceof Blob) {
        if (String(responseBlob.type || "").includes("application/json")) {
          const text = await responseBlob.text();
          let parsed;
          try {
            parsed = JSON.parse(text);
          } catch (_e) {
            message.error(text);
            return;
          }
          if (String(parsed?.code) !== "1") {
            message.error(parsed?.msg);
            return;
          }
          const blob = toBlob(parsed?.data, "application/pdf");
          downloadBlob(
            blob,
            `General_Ledger_${dayjs().format("YYYYMMDD")}.pdf`,
          );
          return;
        }

        downloadBlob(
          toBlob(responseBlob, "application/pdf"),
          `General_Ledger_${dayjs().format("YYYYMMDD")}.pdf`,
        );
        return;
      }

      message.error("Invalid response");
    } catch (e) {
      message.error(e?.message);
    } finally {
      setExportPdfLoading(false);
    }
  };

  const handleExportCsv = async () => {
    if (exportCsvLoading) return;
    setExportCsvLoading(true);
    try {
      const params = await getExportParams();
      const responseBlob = await http.post(api.getGeneralLedgerToCsv, params, {
        responseType: "blob",
      });

      if (responseBlob instanceof Blob) {
        if (String(responseBlob.type || "").includes("application/json")) {
          const text = await responseBlob.text();
          let parsed;
          try {
            parsed = JSON.parse(text);
          } catch (_e) {
            message.error(text);
            return;
          }
          if (String(parsed?.code) !== "1") {
            message.error(parsed?.msg);
            return;
          }
          const blob = toBlob(parsed?.data, "text/csv;charset=utf-8");
          downloadBlob(
            blob,
            `General_Ledger_${dayjs().format("YYYYMMDD")}.csv`,
          );
          return;
        }

        downloadBlob(
          toBlob(responseBlob, "text/csv;charset=utf-8"),
          `General_Ledger_${dayjs().format("YYYYMMDD")}.csv`,
        );
        return;
      }

      message.error("Invalid response");
    } catch (e) {
      message.error(e?.message);
    } finally {
      setExportCsvLoading(false);
    }
  };

  // 定义日期
  const isSpecialRow = (record) =>
    [
      "HEADER",
      "SUBTOTAL",
      "SPACER",
      "GRAND_TOTAL",
      "BUSINESS LICENSE",
    ].includes(record?.rowType);
  const isSubtotalRow = (record) => record?.rowType === "SUBTOTAL";
  const initColumns = [
    {
      title: "Date",
      dataIndex: "date",
      width: 110,
      render: (text, record) => {
        if (isSpecialRow(record)) {
          return (
            <span>{record?.glAcct || ""}</span>
          );
        }
        return text;
      },
    },

    {
      title: "Prop",
      dataIndex: "prop",
      width: 70,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: 70,
    },
    {
      title: "Tenant",
      dataIndex: "tenant",
      width: 70,
    },
    // {
    //   title: "Check No",
    //   dataIndex: "checkNo",
    //   width: 90,
    // },
    {
  title: "Check No",
  dataIndex: "checkNo",
  width: 90,
  render: (text, record) => {
    if (isSpecialRow(record)) return null;
    if (isCheckNoClickable(record)) {
      return (
        <a onClick={() => handleOpenCheckNoDetail(record)}>{text}</a>
      );
    }
    return text;
  },
},
    {
      title: "Description",
      dataIndex: "remark",
      width: 240,
      render: (text, record) => {
        if (isSpecialRow(record)) {
          return (
            <span>
              {record?.remark || record?.title || ""}
            </span>
          );
        }
        return text;
      },
    },
    {
      title: "GL Acct",
      dataIndex: "glAcct",
      width: 80,
      render: (text, record) => {
        if (isSpecialRow(record)) return null;
        return text;
      },
    },
    {
      title: "Debit",
      dataIndex: "debit",
      width: 100,
      isBracketAmountFlag: true,
    },
    {
      title: "Credit",
      dataIndex: "credit",
      width: 100,
      isBracketAmountFlag: true,
    },
    {
      title: "Balance",
      dataIndex: "balance",
      width: 110,
      isBracketAmountFlag: true,
    },
    {
      title: "Ref 2 / Cons",
      dataIndex: "vendor",
      width: 190,
      render: (text, record) => {
        if (record?.vendor && record?.vendorName) {
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span>{record.vendorName}</span>
              <span>({record.vendor})</span>
            </div>
          );
        }
        return record?.vendor || record?.vendorName || "";
      },
    },
    {
      title: "Jnl",
      dataIndex: "journal",
      width: 50,
    },
    {
      title: "Batch",
      dataIndex: "batch",
      width: 80,
    },
    {
      title: "Usid",
      dataIndex: "usid",
      width: 80,
    },
    {
      title: "Sys Date",
      dataIndex: "sysDate",
      width: 110,
    },
  ];

  const columns = initColumns.map((column) => ({
    ...column,
    align: column.isBracketAmountFlag ? "right" : "left",
    className: column.isBracketAmountFlag ? "general-ledger-amount" : undefined,
  }));


const isCheckNoClickable = (record) =>
  record?.haveCheckNoDetail === true && !!record?.checkNo;
const handleOpenCheckNoDetail = (record) => {
  setCheckNoRecord(record);
  setCheckNoModalOpen(true);
};
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [filterForm] = Form.useForm();
  const [presetYear, setPresetYear] = useState(dayjs().year());
  // 下拉框数据

function useLazySelect(apiUrl, mapper, enableCache = true) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false); // 同步标记，防止并发重复请求

  const load = async (params = {}) => {
    if (options.length && enableCache) return; // 已有缓存数据，跳过
    if (loadingRef.current) return;             // 正在请求中，跳过

    loadingRef.current = true;
    setLoading(true);
    try {
      const res = await http.get(apiUrl, Object.keys(params).length ? { params } : undefined);
      const raw = Array.isArray(res) ? res : res?.data || [];
      setOptions(mapper(raw));
    } catch (_error) {
      message.warning("Filter options could not be loaded.");
    } finally {
      setLoading(false);
      loadingRef.current = false;
    }
  };

  return { options, loading, load };
}

  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendorLoading, setVendorLoading] = useState(false);
  const vendorReqIdRef = useRef(0);
  const vendorSearchTimerRef = useRef(null);

  const trustSelect = useLazySelect(api.getTrustDictList, (data) =>
    data.map((d) => ({
      label: d.trustNameTitle,
      value: d.trustId,
    })),
  );

  const companySelect = useLazySelect(api.getCompanyDictList, (data) =>
    data.map((d) => ({
      label: d.companyNameCode,
      value: d.companyId,
    })),
  );

  const ownerSelect = useLazySelect(api.getOwnerDictList, (data) =>
    data.map((d) => ({
      label: d.titleName,
      value: d.ownerId,
    })),
  );

  const propTypeSelect = useLazySelect(api.getPropTypeList, (data) =>
    data.map((d) => ({
      label: d.name,
      value: d.code,
    })),
  );

  const vendorSearch = async (content = "") => {
    const reqId = ++vendorReqIdRef.current;
    setVendorLoading(true);
    try {
      const response = await http.get(api.vendorSearch, {
        params: { content },
      });
      if (reqId !== vendorReqIdRef.current) return [];

      const resData =
        response?.code === "1"
          ? (response.data || []).map((item) => ({
              value: item.vendid,
              label: item.vendorName,
              vendorId: item.vendorId,
            }))
          : [];

      setVendorOptions(resData);
      return resData;
    } catch (_error) {
      if (reqId === vendorReqIdRef.current) message.warning("Vendor options could not be loaded.");
      return [];
    } finally {
      if (reqId === vendorReqIdRef.current) setVendorLoading(false);
    }
  };

  const handleVendorSearch = (content) => {
    if (vendorSearchTimerRef.current)
      clearTimeout(vendorSearchTimerRef.current);
    vendorSearchTimerRef.current = setTimeout(() => {
      vendorSearch(content);
    }, 300);
  };

  const typeOptions = [
    { label: "Gl Acct.", value: "gl_acct" },
    { label: "Trust", value: "trust" },
  ];

  // 日期计算
  const buildReportParams = (values = {}) => {
    const today = dayjs();
    const defaultRange = [today.startOf("month"), today.endOf("month")];
    const range =
      values?.dateRange?.length === 2 ? values.dateRange : defaultRange;
    const [from, to] = range;
    const cleanText = (v) => (typeof v === "string" ? v.trim() : v);
    const cleanList = (v) => (Array.isArray(v) ? v : []);

    return {
      dateFrom: from?.format("YYYY-MM-DD"),
      dateTo: to?.format("YYYY-MM-DD"),
      prop: cleanText(values?.prop) || "",
      glAcct: cleanText(values?.glAcct) || "",
      batch: cleanText(values?.batch) || "",
      type: cleanText(values?.type) || "",
      vendidList: cleanList(values?.vendidList),
      trustIdList: cleanList(values?.trustIdList),
      companyIdList: cleanList(values?.companyIdList),
      ownerIdList: cleanList(values?.ownerIdList),
      propTypeList: cleanList(values?.propTypeList),
    };
  };

  const rangePresets = (() => {
    const today = dayjs();

    // 根据当前查看的年份，动态生成 Jan ~ Dec
    const monthPresets = Array.from({ length: 12 }, (_, index) => {
      const month = dayjs().year(presetYear).month(index);

      return {
        label: month.format("MMMM"),
        value: [month.startOf("month"), month.endOf("month")],
      };
    });

    return [
      {
        label: (
          <span
            style={{
              fontWeight: 600,
              color: "#666",
              pointerEvents: "none",
            }}
          >
            Quick Select
          </span>
        ),
        value: null,
      },

      {
        label: "Today",
        value: [today, today],
      },

      {
        label: "Yesterday",
        value: [today.subtract(1, "day"), today.subtract(1, "day")],
      },

      {
        label: "Last 7 Days",
        value: [today.subtract(6, "day"), today],
      },

      {
        label: "Last 30 Days",
        value: [today.subtract(29, "day"), today],
      },

      {
        label: "This Month",
        value: [today.startOf("month"), today.endOf("month")],
      },

      {
        label: "Last Month",
        value: [
          today.subtract(1, "month").startOf("month"),
          today.subtract(1, "month").endOf("month"),
        ],
      },
      {
        label: (
          <span
            className="preset-group-title"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            Months ({presetYear})
          </span>
        ),
        value: null,
      },

      ...monthPresets,
      // {
      //   label: (
      //     <span
      //       style={{
      //         fontWeight: 600,
      //         color: "#666",
      //         pointerEvents: "none",
      //       }}
      //     >
      //       Year
      //     </span>
      //   ),
      //   value: null,
      // },

      // {
      //   label: "This Year",
      //   value: [today.startOf("year"), today.endOf("year")],
      // },

      // {
      //   label: "Last Year",
      //   value: [
      //     today.subtract(1, "year").startOf("year"),
      //     today.subtract(1, "year").endOf("year"),
      //   ],
      // },
    ];
  })();
  const handleRunReport = async (values) => {
    const params = buildReportParams(values);
    await getTableListFn(1, 25, params);
  };
  //  表格数据
  const getTableListFn = async (_current, _pageSize, paramsOverride) => {
    const controller = createController();

    const params =
      paramsOverride || buildReportParams(filterForm.getFieldsValue());

    setTableLoading(true);

    try {
      const response = await http.post(api.getGeneralLedgerShow, params, {
        signal: controller.signal,
      });
      if (!response) return;

      if (response.code !== "1") {
        commonFn.modalFailedFn(response);
        return;
      }

      setReportPeriod(`${dayjs(params.dateFrom).format("M/D/YYYY")} - ${dayjs(params.dateTo).format("M/D/YYYY")}`);

      const rawList = (response?.data?.rows || []).map((item, index) => ({
        ...item,
        key: `${item.glAcct || "row"}-${index}`,
        "#": index + 1,
      }));

      setTableList(rawList);
    } catch (err) {
      if (!controller.signal.aborted) message.error(err?.message || "Unable to run the report.");
    } finally {
      setTableLoading(false);
    }
  };
  useEffect(() => {
    const today = dayjs();

    const initialValues = {
      type: "gl_acct",
      dateRange: [today.startOf("month"), today.endOf("month")],
      prop: "",
      glAcct: "",
      batch: "",
      vendidList: [],
      trustIdList: [],
      companyIdList: [],
      ownerIdList: [],
      propTypeList: [],
    };

    filterForm.setFieldsValue(initialValues);

    return () => {
      clearTimeout(vendorSearchTimerRef.current);
      cancelAllRequests();
    };
  }, []);
  // Use the available preview height, not a viewport offset that creates an outer scrollbar.
  useEffect(() => {
    const host = tableHost.current;
    if (!host) return undefined;
    const resize = () => setTableHeight(Math.max(80, host.clientHeight - (host.querySelector(".ant-table-header")?.offsetHeight || 54) - 6));
    const observer = new ResizeObserver(resize);
    observer.observe(host);
    resize();
    return () => observer.disconnect();
  }, [tableList, filtersCollapsed]);

  const resetReport = () => {
    cancelAllRequests();
    filterForm.resetFields();
    filterForm.setFieldsValue({ type: "gl_acct", dateRange: [dayjs().startOf("month"), dayjs().endOf("month")], prop: "", glAcct: "", batch: "", vendidList: [], trustIdList: [], companyIdList: [], ownerIdList: [], propTypeList: [] });
    setOwnerGroupId(null);
    setTableList([]);
    setReportPeriod("");
    setRefreshKey((key) => key + 1);
  };
  return (
    <main className="one-line-cash-flow-page general-ledger-page">
      <section className={`one-line-layout${filtersCollapsed ? " one-line-layout-filters-collapsed" : ""}`}>
        {/* Keep fields registered so hidden filters still participate in validation and export. */}
        <Card className="one-line-filter-card" style={filtersCollapsed ? { display: "none" } : undefined} title={
          <div className="one-line-filter-header">
            <div className="one-line-filter-title-row"><span>Report filters</span><Button className="one-line-collapse-button" type="text" icon={<UpOutlined />} onClick={() => setFiltersCollapsed(true)}>Hide filters</Button></div>
            <div className="one-line-filter-actions"><Button icon={<ReloadOutlined />} onClick={resetReport}>Reset</Button><Button type="primary" icon={<PlayCircleOutlined />} loading={tableLoading} onClick={() => filterForm.submit()}>Run Report</Button></div>
          </div>
        }>
                  <Form
                    form={filterForm}
                    layout="vertical"
                    onFinish={handleRunReport}
                    onValuesChange={(changed) => { if (Object.prototype.hasOwnProperty.call(changed, "ownerIdList")) setOwnerGroupId(null); }}
                  >
                    <Form.Item
                      label="Group By"
                      name="type"
                      rules={[
                        { required: true, message: "Please select Group By" },
                      ]}
                    >
                      <Select
                        placeholder="Gl Acct."
                        options={typeOptions}
                        allowClear
                      />
                    </Form.Item>

                    <Form.Item
                      label="From/To Date"
                      name="dateRange"
                      rules={[
                        { required: true, message: "Please select date range" },
                      ]}
                    >
                      <RangePicker
                        style={{ width: "100%" }}
                        presets={rangePresets}
                        onPanelChange={(values) => {
                          if (values?.[0]) {
                            setPresetYear(values[0].year());
                          }
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Property"
                      name="prop"
                      rules={[{ required: true, message: "Please input Prop" }]}
                    >
                      <Input.TextArea className="one-line-property-input" rows={3} placeholder="e.g. 0001, 1005-1010" />
                    </Form.Item>

                    <Form.Item label="Vendor" name="vendidList">
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        filterOption={false}
                        maxTagCount={5}
                        optionLabelProp="value"
                        maxTagPlaceholder={(omittedValues) =>
                          `+${omittedValues.length}...`
                        }
                        placeholder="Search vendor"
                        options={vendorOptions}
                        loading={vendorLoading}
                        onSearch={handleVendorSearch}
                        onDropdownVisibleChange={(open) =>
                          open && vendorSearch("")
                        }
                      />
                    </Form.Item>

                    <Form.Item label="Trust" name="trustIdList">
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        maxTagCount={5}
                        maxTagPlaceholder={(omittedValues) =>
                          `+${omittedValues.length}...`
                        }
                        placeholder="Trust"
                        options={trustSelect.options}
                        loading={trustSelect.loading}
                        onDropdownVisibleChange={(open) =>
                          open && trustSelect.load()
                        }
                      />
                    </Form.Item>

                    <Form.Item label="Company" name="companyIdList">
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        maxTagCount={5}
                        maxTagPlaceholder={(omittedValues) =>
                          `+${omittedValues.length}...`
                        }
                        placeholder="Nothing selected"
                        options={companySelect.options}
                        loading={companySelect.loading}
                        onDropdownVisibleChange={(open) =>
                          open && companySelect.load()
                        }
                      />
                    </Form.Item>

                    <Form.Item label="Owner" name="ownerIdList">
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        maxTagCount={5}
                        maxTagPlaceholder={(omittedValues) =>
                          `+${omittedValues.length}...`
                        }
                        placeholder="Nothing selected"
                        options={ownerSelect.options}
                        loading={ownerSelect.loading}
                        onDropdownVisibleChange={(open) =>
                          open && ownerSelect.load()
                        }
                      />
                    </Form.Item>

                    {/* <OwnerGroupPicker value={ownerGroupId} ownerOptions={ownerSelect.options} loadOwners={ownerSelect.load} onSelect={(group) => {
                      setOwnerGroupId(group?.id ?? null);
                      filterForm.setFieldsValue({ ownerIdList: group?.ownerIds || [] });
                      ownerSelect.load();
                    }} /> */}

                    <Form.Item label="Property Type" name="propTypeList">
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        maxTagCount={5}
                        maxTagPlaceholder={(omittedValues) =>
                          `+${omittedValues.length}...`
                        }
                        placeholder="Nothing selected"
                        options={propTypeSelect.options}
                        loading={propTypeSelect.loading}
                        onDropdownVisibleChange={(open) =>
                          open && propTypeSelect.load()
                        }
                      />
                    </Form.Item>

                    <Form.Item label="Batch" name="batch">
                      <Input placeholder="Batch" />
                    </Form.Item>

                    <Form.Item label="Gl Acct" name="glAcct">
                      <Input placeholder="Gl Acct" />
                    </Form.Item>

                  </Form>
        </Card>
        <div className="one-line-report-column">
          {filtersCollapsed && <div className="one-line-show-filters"><Button className="one-line-collapse-button" type="text" icon={<DownOutlined />} onClick={() => setFiltersCollapsed(false)}>Show filters</Button></div>}
          <Card className="one-line-result-card" title="Report preview" extra={<Space>
            <Button aria-label="Refresh report" icon={<ReloadOutlined />} loading={tableLoading} onClick={() => filterForm.submit()} />
            <Button icon={<FileTextOutlined />} loading={exportCsvLoading} onClick={handleExportCsv}>CSV</Button>
            <Button type="primary" icon={<FilePdfOutlined />} loading={exportPdfLoading} onClick={handleExportPdf}>PDF</Button>
          </Space>}>
            <div className="one-line-result-toolbar"><Typography.Text className="one-line-result-subtitle">{reportPeriod || "Run the report to review data before exporting."}</Typography.Text></div>
            <div ref={tableHost} className="one-line-table-host">
                <CustomTable
                  refreshKey={refreshKey}
                  tableLoading={tableLoading}
                  columns={columns}
                  tableList={tableList}
                  rowClassName={(record) => {
                    const classes = [];
                    if (isSpecialRow(record)) classes.push("report-bold-row");
                    if (record.rowType === "SPACER") classes.push("general-ledger-spacer-row");
                    if (record.rowType === "HEADER") classes.push("one-line-group-row");
                    if (isSubtotalRow(record) || record.rowType === "GRAND_TOTAL") classes.push("one-line-total-row");
                    return classes.join(" ");
                  }}
                  tableScroll={{ x: "max-content", y: tableHeight }}
                  tableCss="one-line-table general-ledger-table"
                  rowKey="key"
                  size="small"
                />
            </div>
          </Card>
        </div>
        <CheckNoDetailModal
  open={checkNoModalOpen}
  onCancel={() => setCheckNoModalOpen(false)}
  record={checkNoRecord}
/>
      </section>
    </main>
  );
});

export default ReportPage;
